let eventId = document.querySelector('input[name="event_id"]');
let salesStoppedText = document.querySelector('input[name="sales_stopped_text"]');
let button = document.querySelector('#buy-button');

if (eventId && button) {
    fetch("/is-available-event/" + eventId.value)
        .then(response => response.json())
        .then(data => {
            if (data.available) {
                button.classList.remove('disabled-buy');
            } else {
                button.innerHTML = salesStoppedText.value
            }
        })
        .catch(error => {
            console.log(error)
        });
}